"use strict";Object.defineProperty(exports, "__esModule", {value: true});



/* What a skipped row's server error is about: the patient field it names
 * (null when it's about the row as a whole) and how to say it. */
 const rowErrorReason = (error



) => {
  if (/no phone or email/i.test(error)) return { field: null, problem: 'blank', text: 'No phone or email' }
  if (/phone/i.test(error)) return { field: 'phone', problem: 'invalid', text: "Phone isn't valid" }
  if (/date/i.test(error)) return { field: 'dob', problem: 'invalid', text: "Date of birth isn't valid" }
  if (/more than one row/i.test(error)) return { field: 'mrn', problem: 'repeated', text: 'MRN is on more than one row' }
  return { field: null, problem: 'other', text: error.charAt(0).toUpperCase() + error.slice(1) }
}; exports.rowErrorReason = rowErrorReason













/* Rev 31 v2 · 4a: the Map columns Status, one per column in `columns`. The
 * rows a column's values leave missing or can't add are in step 2. */
 const columnStatuses = ({ columns, mapping, declared }) => {
  const byColumn = new Map(mapping.map(m => [m.Column, m]))
  return columns.map(column => {
    const m = byColumn.get(column.Index)
    if (!m || m.Destination === 'ignore') return { label: 'Skipped', tone: 'ignore' }
    if (m.Destination === 'variable' && !declared.has(m.Variable)) return { label: 'New variable', tone: 'variable' }
    return { label: 'Matched', tone: 'ok' }
  })
}; exports.columnStatuses = columnStatuses
